/**
 * Logs multipart keys and values (files/blobs as name + size) for debugging.
 * Duplicate keys (e.g. multiple downloadedfiles) each get their own line.
 *
 * Runs when NODE_ENV is development, or when REACT_APP_DEBUG_FORMDATA=true (e.g. staging).
 */
export async function logFormDataPayload(formData, tag = "FormData") {
  const enabled =
    process.env.NODE_ENV === "development" ||
    process.env.REACT_APP_DEBUG_FORMDATA === "true";
  if (!enabled) return;

  console.group(tag);
  for (const [key, value] of formData.entries()) {
    if (value instanceof File) {
      console.log(key, `[File] ${value.name} (${value.size} bytes)`);
    } else if (value instanceof Blob) {
      const meta = `[Blob] type=${value.type || "(empty)"} (${value.size} bytes)`;
      if (value.size <= 4096) {
        const t = await value.text();
        console.log(key, meta, "→", t);
      } else {
        console.log(key, meta);
      }
    } else {
      console.log(key, value);
    }
  }
  console.groupEnd();
}
